import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationSnackbarService {
  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly zone: NgZone
  ) {}

  default(message: string, action: string) {
    this.show(message, action, {
      duration: 2000,
      panelClass: ''
    });
  }

  info(message: string, action: string) {
    this.show(message, action, {
      duration: 2000,
      panelClass: 'bg-info'
    });
  }

  success(message: string, action: string) {
    this.show(message, action, {
      duration: 2000,
      panelClass: 'bg-success'
    });
  }

  warn(message: string, action: string) {
    this.show(message, action, {
      duration: 2500,
      panelClass: 'bg-warning'
    });
  }

  error(message: string, action: string) {
    this.show(message, action, {
      duration: 3000,
      panelClass: 'bg-danger'
    });
  }

  private show(message: string, action: string, configuration: MatSnackBarConfig) {
    // Need to open snackBar from Angular zone to prevent issues with its position per
    // https://stackoverflow.com/questions/50101912/snackbar-position-wrong-when-use-errorhandler-in-angular-5-and-material
    this.zone.run(() => this.snackBar.open(message, action, configuration));
  }
}
